import React from "react";
import InvoicePageSection from "../../Sections/InvoicePageSection/Content";
const InvoicePage = () => {
  return <InvoicePageSection />;
};

export default InvoicePage;
